<template>
  <button class="start-btn" :class="type" :style="widthStyle" @click="handleTry">
    {{ text }}
    <slot name="icon">
      <ArrowRight class="icon text-[22px]" filled />
    </slot>
  </button>
</template>

<script lang="ts" setup>
/** 开发场景详情时，改成了通用，但是没有移动位置 */

import type { CSSProperties } from 'vue';
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
const props = withDefaults(
  defineProps<{
    text?: string;
    type?: string;
    widthStyle?: CSSProperties;
    handler?: () => void;
  }>(),
  {
    text: '免费试用',
    type: 'default',
  },
);
const handleTry = () => {
  if (props.handler) {
    props.handler();
    return;
  }
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};
</script>

<style lang="scss" scoped>
.start-btn {
  @apply flex gap-3 items-center justify-center;
  width: 210px;
  height: 58px;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  background-color: var(--x-text-1);
  color: var(--x-white-1);
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  transition: all 0.3s ease;

  &:hover {
    // background-color: var(--text-3);
    background-color: #414751;
  }
  &.default {
    width: 210px;
    height: 58px;
  }
  &.small {
    width: 178px;
    height: 48px;
  }
}
</style>
